function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.3 3.2C2 3.2 1 4.3 1 5.5v9c0 1.2 1 2.2 2.2 2.2h13.5c1.2 0 2.2-1 2.2-2.2v-9c0-1.2-1-2.2-2.2-2.2H3.3zM4 5c-.6 0-1 .4-1 1v2h2.1c.9 0 1.8.4 2.4 1 1.4 1.4 3.6 1.4 4.9 0 .7-.6 1.6-1 2.6-1h2V6c0-.6-.4-1-1-1H4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgWallet;